import { api } from '../api/api';

/** Terms of use and privacy notice for the login page; only the demo server sets them. */
export interface LegalLinks {
  termsUrl: string | null;
  privacyUrl: string | null;
}

export async function fetchLegalLinks(): Promise<LegalLinks> {
  const response = await api.get<LegalLinks>('/api/public/legal-links');
  return response.data;
}
